module.exports = __webpack_public_path__ + "static/media/murari.dea29cfc.png";